const angular = require('angular')
const mailService = require('./mailService')
const Message = require('./Message')
const MailFolderType = require('./MailFolderType')
const mailFolderService = require('./mailFolderService')
const mailFolderCtrl = require('./mailFolderCtrl')
const messageItem = require('./messageItem')
const folderItem = require('./folderItem')
const folderNameFilter = require('./folderNameFilter')
const StorageMailFolder = require('./StorageMailFolder')
const SearchMailFolder = require('./SearchMailFolder')
const KeywordSearchMail = require('./KeywordSearchMail')
const MailDealingFolder = require('./MailDealingFolder')
const watermark = require('../directives/watermark')
const mailDealingCtrl = require('./mailDealingCtrl')
const mutilForwardReplySimplifyFilter = require('./mutilForwardReplySimplifyFilter')
require('./read/module')
require('./compose/module')

module.exports = angular.module('hxphone.mail', ['hxphone.services', 'hxphone.read', 'hxphone.compose', 'hxphone.infrastructure'])
  .service('Message', Message)
  .service('MailFolderType', MailFolderType)
  .service('mailService', mailService)
  .service('mailFolderService', mailFolderService)
  .controller('mailFolderCtrl', mailFolderCtrl)
  .controller('mailDealingCtrl', mailDealingCtrl)
  .directive('messageItem', messageItem)
  .directive('watermark', watermark)
  .directive('folderItem', folderItem)
  .filter('transform', folderNameFilter)
  // html不要转义输出
  .filter('trustedHtml', [
    '$sce',
    function($sce) {
      return function (text) {
        return $sce.trustAsHtml(text)
      }
    }
  ])
  .filter('convertedHttpLink', [
    function () {
      return function (text) {
        return text.replace(/((?:ht|f)tps?:\/\/.*?)(?:\s|$)/ig, '<a target="_blank" href="$1">$1</a>')
      }
    }
  ])
  .filter('mutilForwardReplySimplifyFilter', mutilForwardReplySimplifyFilter)
  .service('StorageMailFolder', StorageMailFolder)
  .service('SearchMailFolder', SearchMailFolder)
  .service('KeywordSearchMail', KeywordSearchMail)
  .service('MailDealingFolder', MailDealingFolder)



// WEBPACK FOOTER //
// ./src/js/mail/module.js